<template>
  <div class="container">
    <div
      class="media1"
      v-for="(rg, index) in registros"
      :key="index"
      v-bind:class="{ 'is-total': rg.esTotal }"
    >
      <y-viewregistro
        :index="index"
        :fila="fila"
        :columna="columna"
        :reg="rg"
        :selection="selection"
        :selcolumn="selcolumn"
        @fila="changeFila"
        @columna="changeColumna"
      ></y-viewregistro>
      <y-formregistro
        v-if="showInput(index)"
        :index="index"
        :fila="fila"
        :reg="registros"
        :columna="columna"
        :selection="selection"
        :selcolumn="selcolumn"
        :lengthReg="registros.length"
        :comundata="comundata"
        @deleteReg="deleteReg"
        @validaReg="validaRegistro"
        @newReg="addReg"
        @fila="changeFila"
        @columna="changeColumna"
        @changeInputReg="changeData"
        @f10guardar="f10guardar"
      ></y-formregistro>
    </div>
    <div
      v-if="
        comundata.comprobante.estructura === 'comercial' &&
        comundata.comprobante.esfactura
      "
    >
      <div class="field margin-top">
        <div class="control">
          <textarea
            v-model="textoFactura"
            class="textarea is-large"
            placeholder="Texto personalizado de la factura"
          ></textarea>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import yFormregistro from "@/components/registrar/Formregistro.vue";
import yViewregistro from "@/components/registrar/Viewregistro.vue";
import functions from "@/helpers/functions";
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
const selectioncomercial = [
  // la idea de seleccion es tener configurado cada boton que aparece en el formulario cod es como esta en el registro, nombre es como aparece el boton bd es como se guarda en la base de datos tiene es si la cuenta exige ese campo valida es si esta validado el campo, texto donde esta el texto ya sea de la cuenta o del nit referencia etc
  {
    cod: "cuenta",
    nombre: "Cuenta",
    bd: "idcuenta",
    tiene: "tCuenta",
    valida: "cumpleCuenta",
    texto: "nombreCuenta",
  },
  {
    cod: "nit",
    nombre: "Nit",
    bd: "idnit",
    tiene: "tNit",
    valida: "cumpleNit",
    texto: "nombreNit",
  },
  {
    cod: "descripcion",
    nombre: "Descripción",
    bd: "descripcion",
    tiene: "tDescripcion",
    valida: "cumpleDescripcion",
    texto: "descripcion",
  },
  {
    cod: "docRef",
    nombre: "Referencia",
    bd: "docRef",
    tiene: "tDocref",
    valida: "cumpleRef",
    texto: "docRef",
  },
  {
    cod: "ccostos",
    nombre: "C Costos",
    bd: "ccostos",
    tiene: "tCcosto",
    valida: "cumpleCcosto",
    texto: "nombreCcostos",
  },
  {
    cod: "base",
    nombre: "Base",
    bd: "base",
    tiene: "tBase",
    valida: "cumpleBase",
    texto: "base",
  },
  {
    cod: "tipo1",
    nombre: "+",
    bd: "tipo1",
    tiene: "tTipo",
    valida: "cumpleTipo1",
    texto: "tipo1",
  },
  {
    cod: "valor",
    nombre: "Valor",
    bd: "valor",
    tiene: "tValor",
    valida: "cumpleValor",
    texto: "valor",
  },
];

const selectioninventario = [
  // la idea de seleccion es tener configurado cada boton que aparece en el formulario cod es como esta en el registro, nombre es como aparece el boton bd es como se guarda en la base de datos tiene es si la cuenta exige ese campo valida es si esta validado el campo, texto donde esta el texto ya sea de la cuenta o del nit referencia etc
  {
    cod: "cuenta",
    nombre: "Cuenta",
    bd: "idcuenta",
    tiene: "tCuenta",
    valida: "cumpleCuenta",
    texto: "nombreCuenta",
  },
  {
    cod: "nit",
    nombre: "Nit",
    bd: "idnit",
    tiene: "tNit",
    valida: "cumpleNit",
    texto: "nombreNit",
  },
  {
    cod: "nproducto",
    nombre: "Producto",
    bd: "producto",
    tiene: "tProducto",
    valida: "cumpleProducto",
    texto: "nombreproducto",
  },
  {
    cod: "cantidad",
    nombre: "Cantidad",
    bd: "cantidad",
    tiene: "tCantidad",
    valida: "cumpleCantidad",
    texto: "cantidad",
  },
  {
    cod: "vlrUnitario",
    nombre: "P Unit",
    bd: "vlrUnitario",
    tiene: "tPreciounitario",
    valida: "cumplePreciounitario",
    texto: "vlrUnitario",
  },
  {
    cod: "nbodega",
    nombre: "Bodega",
    bd: "bodega",
    tiene: "tBodega",
    valida: "cumpleBodega",
    texto: "nombrebodega",
  },
  {
    cod: "descripcion",
    nombre: "Descripción",
    bd: "descripcion",
    tiene: "tDescripcion",
    valida: "cumpleDescripcion",
    texto: "descripcion",
  },
  {
    cod: "docRef",
    nombre: "Referencia",
    bd: "docRef",
    tiene: "tDocref",
    valida: "cumpleRef",
    texto: "docRef",
  },
  {
    cod: "ccostos",
    nombre: "C Costos",
    bd: "ccostos",
    tiene: "tCcosto",
    valida: "cumpleCcosto",
    texto: "nombreCcostos",
  },
  {
    cod: "base",
    nombre: "Base",
    bd: "base",
    tiene: "tBase",
    valida: "cumpleBase",
    texto: "base",
  },
  {
    cod: "tipo1",
    nombre: "+",
    bd: "tipo1",
    tiene: "tTipo",
    valida: "cumpleTipo1",
    texto: "tipo1",
  },
  {
    cod: "valor",
    nombre: "Valor",
    bd: "valor",
    tiene: "tValor",
    valida: "cumpleValor",
    texto: "valor",
  },
];

export default {
  props: {
    comundata: {
      type: Object,
    },
    borrador: Object,
    guardando: Boolean,
    turno: Object,
  },
  computed: {
    ...mapState([
      "idtoken",
      "empresa",
      "cuentas",
      "nits",
      "productos",
      "bodegas",
    ]),
    comprobanteSelected() {
      return this.comundata.comprobante;
    },
  },
  data() {
    return {
      registros: [],
      fila: 0,
      columna: 1,
      textoFactura: "",
      selection: [],
      editsel: false,
      selcolumn: {
        columnValor: 0,
        columnBase: 0,
        columnccostos: 0,
        columndocRef: 0,
        columndescripcion: 0,
        columnnit: 0,
        columncuenta: 0,
        columntipo1: 0,
        columnproducto: 0,
        columncantidad: 0,
        columnpunitario: 0,
        columnbodega: 0,
      },
    };
  },
  methods: {
    f10guardar() {
      this.$emit("f10guardar");
    },
    deleteReg(payload) {
      this.registros.splice(payload, 1);
      this.fila = payload - 1;
    },
    showInput(f) {
      if (this.fila === f) {
        return true;
      } else {
        return false;
      }
    },
    changeData(payload) {
      // si esta en la columna total no puede editar el valor
      if (this.registros[payload.fila].esTotal) {
        if (this.columna !== this.selcolumn.columnValor) {
          this.registros[payload.fila][
            this.selection[payload.columna - 1].cod
          ] = payload.data;
        }
      } else {
        this.registros[payload.fila][this.selection[payload.columna - 1].cod] =
          payload.data;
        if (this.columna === this.selcolumn.columnValor) {
          const temporal = this.calculaTotal(this.fila);
          this.registros[this.registros.length - 1].valor = temporal;
        }
      }
    },
    calculaTotal(fila) {
      let total = 0;
      const _this = this;
      this.registros.forEach(function (k, v) {
        let multiplicador = 1;
        if (v !== _this.registros.length - 1) {
          if (_this.registros[v].tipo1 === "-") {
            multiplicador = -1;
          }
          total += parseFloat(_this.registros[v].valor) * multiplicador;
        }
      });
      return total;
    },
    changeFila(n) {
      this.fila = n;
    },
    changeColumna(n) {
      this.columna = n;
    },
    addReg() {
      this.createreg(this, true);
    },
    validaRegistro() {
      this.validaRenglon(this.fila);
    },
    validaCuenta(fila, _this) {
      const data = functions.findData(
        this.cuentas,
        this.registros[fila].cuenta,
        "codigo"
      );
      if (data) {
        _this.registros[fila].cuentadetalle = data;
        _this.registros[fila].cumpleCuenta = true;
        _this.registros[fila].cumpleNit = true;
        _this.registros[fila].cumpleDescripcion = true;
        _this.registros[fila].cumpleRef = true;
        _this.registros[fila].cumpleCcosto = true;
        _this.registros[fila].cumpleBase = true;
        _this.registros[fila].cumpleProducto = true;
        _this.registros[fila].cumpleCantidad = true;
        _this.registros[fila].cumplePreciounitario = true;
        _this.registros[fila].cumpleBodega = true;
        _this.registros[fila].cumpleValor = true;
        _this.registros[fila].cumpleTipo1 = true;
        _this.registros[fila].cumpleTodo = false;
        _this.registros[fila].porcentaje = null;
        _this.registros[fila].tCuenta = true;
        _this.registros[fila].tNit = false;
        _this.registros[fila].tDescripcion = true;
        _this.registros[fila].tCcosto = false;
        _this.registros[fila].tBase = false;
        _this.registros[fila].tDocref = false;
        _this.registros[fila].tProducto = false;
        _this.registros[fila].tCantidad = false;
        _this.registros[fila].tPreciounitario = false;
        _this.registros[fila].tBodega = false;
        _this.registros[fila].tTipo = true;
        _this.registros[fila].tValor = true;
        _this.registros[fila].turno = null;
        _this.registros[fila].tipor = null;
        _this.registros[fila][this.selection[0].texto] = null;
        _this.registros[fila][this.selection[0].bd] = null;
        _this.registros[fila][this.selection[0].texto] = data.nombre;
        _this.registros[fila][this.selection[0].bd] = data._id;
        if (data.base) {
          _this.registros[fila].porcentaje = data.porcentaje;
          _this.registros[fila].tBase = true;
        } else {
          _this.registros[fila].porcentaje = null;
          _this.registros[fila].tBase = false;
        }
        if (data.ccosto) {
          _this.registros[fila].tCcosto = true;
        } else {
          _this.registros[fila].tCcosto = false;
        }
        if (data.dctoref) {
          _this.registros[fila].tDocref = true;
        } else {
          _this.registros[fila].tDocref = false;
        }
        if (data.tercero) {
          _this.registros[fila].tNit = true;
        } else {
          _this.registros[fila].tNit = false;
        }
        if (data.producto) {
          _this.registros[fila].tProducto = true;
          _this.registros[fila].tCantidad = true;
          _this.registros[fila].tPreciounitario = true;
          _this.registros[fila].tBodega = true;
          if (data.inventario) {
            _this.registros[fila].tipor = "inventario";
          }
          if (data.costoProd) {
            _this.registros[fila].tipor = "costo";
          }
          if (data.ingreso) {
            _this.registros[fila].tipor = "ingreso";
          }
        }
      } else {
        _this.registros[fila].porcentaje = null;
        _this.registros[fila][this.selection[0].texto] = null;
        _this.registros[fila][this.selection[0].bd] = null;
        // _this.registros[fila].tBase = false; // no se debería borrar esto con poner que no cumple cuenta es suficiente
        // _this.registros[fila].tCcosto = false;
        // _this.registros[fila].tDocref = false;
        // _this.registros[fila].tNit = false;
        _this.registros[fila].cumpleCuenta = false;
      }
    },
    validaconcepto(fila, colValidar, _this) {
      // en data._id, debe ir lo que se va a guardar en base de datos por eso en descripcion y ccostos se cambia el id por el texto o el codigo
      let data = null;
      if (colValidar === this.selcolumn.columnnit) {
        data = functions.findData(
          _this.nits,
          _this.registros[fila].nit,
          "codigo"
        );
      }
      if (colValidar === this.selcolumn.columndescripcion) {
        if (_this.registros[fila].descripcion) {
          data = {};
          data.nombre = _this.registros[fila].descripcion;
          data._id = _this.registros[fila].descripcion;
        }
      }
      if (colValidar === this.selcolumn.columndocRef) {
        data = {};
        data.nombre = _this.registros[fila].docRef;
        data._id = _this.registros[fila].docRef;
      }
      if (colValidar === this.selcolumn.columnccostos) {
        data = functions.findData(
          _this.comundata.ccostos,
          _this.registros[fila].ccostos,
          "codigo"
        );
        if (data) {
          data._id = data.codigo;
        }
      }
      if (colValidar === this.selcolumn.columnBase) {
        _this.registros[fila].base = parseFloat(_this.registros[fila].base);
        if (_this.registros[fila].base) {
          if (isNaN(_this.registros[fila].base)) {
            // aqui validamos que lo que este en valor si sea un número
            _this.registros[fila].base = null;
          } else {
            if (_this.registros[fila].base === 0) {
              // si el valor es cero no puede pasar
              _this.registros[fila].base = null;
            } else {
              data = {};
              data.nombre = _this.registros[fila].base;
              data._id = _this.registros[fila].base;
            }
          }
        }
      }
      if (colValidar === this.selcolumn.columnValor) {
        if (_this.registros[fila].valor === null) {
          _this.registros[fila].valor = 0;
        }
        _this.registros[fila].valor = parseFloat(_this.registros[fila].valor);
        if (_this.registros[fila].valor) {
          if (isNaN(_this.registros[fila].valor)) {
            // aqui validamos que lo que este en valor si sea un número
            _this.registros[fila].valor = 0;
          } else {
            if (_this.registros[fila].valor === 0) {
              // si el valor es cero no puede pasar
              _this.registros[fila].valor = 0;
            } else if (_this.registros[fila].valor < 0) {
              _this.registros[fila].valor = _this.registros[fila].valor * -1;
              data = {};
              data.nombre = _this.registros[fila].valor;
              data._id = _this.registros[fila].valor;
            } else {
              data = {};
              data.nombre = _this.registros[fila].valor;
              data._id = _this.registros[fila].valor;
            }
          }
        }
      }
      if (colValidar === this.selcolumn.columntipo1) {
        if (_this.registros[fila].tipo1) {
          data = {};
          if (_this.registros[fila].tipo1 === "-") {
            data.nombre = "-";
            data._id = "-";
          } else {
            data.nombre = "+";
            data._id = "+";
          }
        }
      }
      if (colValidar === this.selcolumn.columnproducto) {
        data = functions.findData(
          _this.productos,
          _this.registros[fila].nproducto,
          "codigo"
        );
        if (data) {
          data.nombre = data.descripcion;
          _this.registros[fila].productodetalle = data;
          if (_this.registros[fila].cuentadetalle) {
            let idcuentacomparar;
            if (_this.registros[fila].cuentadetalle.inventario) {
              idcuentacomparar = data.linea.ctaInventario;
            }
            if (_this.registros[fila].cuentadetalle.ingreso) {
              idcuentacomparar = data.linea.ctaIngreso;
            }
            if (_this.registros[fila].cuentadetalle.costoProd) {
              idcuentacomparar = data.linea.ctaCosto;
            }
            _this.cuentas.forEach(function (k, v) {
              if (k._id === idcuentacomparar) {
                _this.registros[fila].cuenta = k.codigo;
              }
            });
            _this.validaCuenta(fila, _this);
          }
        }
      }
      if (colValidar === this.selcolumn.columncantidad) {
        if (_this.registros[fila].cantidad === null) {
          _this.registros[fila].cantidad = 0;
        }
        _this.registros[fila].cantidad = parseFloat(
          _this.registros[fila].cantidad
        );
        if (_this.registros[fila].cantidad) {
          if (isNaN(_this.registros[fila].cantidad)) {
            // aqui validamos que lo que este en valor si sea un número
            _this.registros[fila].cantidad = 0;
          } else {
            if (_this.registros[fila].cantidad === 0) {
              // si el valor es cero no puede pasar
              _this.registros[fila].cantidad = 0;
            } else if (_this.registros[fila].cantidad < 0) {
              _this.registros[fila].cantidad =
                _this.registros[fila].cantidad * -1;
              data = {};
              data.nombre = _this.registros[fila].cantidad;
              data._id = _this.registros[fila].cantidad;
            } else {
              data = {};
              data.nombre = _this.registros[fila].cantidad;
              data._id = _this.registros[fila].cantidad;
            }
          }
        }
      }
      if (colValidar === this.selcolumn.columnpunitario) {
        if (_this.registros[fila].vlrUnitario === null) {
          _this.registros[fila].vlrUnitario = 0;
        }
        _this.registros[fila].vlrUnitario = parseFloat(
          _this.registros[fila].vlrUnitario
        );
        if (_this.registros[fila].vlrUnitario) {
          if (isNaN(_this.registros[fila].vlrUnitario)) {
            // aqui validamos que lo que este en valor si sea un número
            _this.registros[fila].vlrUnitario = 0;
          } else {
            if (_this.registros[fila].vlrUnitario === 0) {
              // si el valor es cero no puede pasar
              _this.registros[fila].vlrUnitario = 0;
            } else if (_this.registros[fila].vlrUnitario < 0) {
              _this.registros[fila].vlrUnitario =
                _this.registros[fila].vlrUnitario * -1;
              data = {};
              data.nombre = _this.registros[fila].vlrUnitario;
              data._id = _this.registros[fila].vlrUnitario;
            } else {
              data = {};
              data.nombre = _this.registros[fila].vlrUnitario;
              data._id = _this.registros[fila].vlrUnitario;
            }
          }
          if (_this.registros[fila][_this.selection[colValidar - 1].tiene]) {
            _this.registros[fila].valor =
              _this.registros[fila].vlrUnitario *
              _this.registros[fila].cantidad;
          }
        }
      }
      if (colValidar === this.selcolumn.columnbodega) {
        data = functions.findData(
          _this.bodegas,
          _this.registros[fila].nbodega,
          "codigo"
        );
        if (data) {
          data.nombre = data.descripcion;
        }
      }
      if (_this.registros[fila][_this.selection[colValidar - 1].tiene]) {
        if (data) {
          _this.registros[fila][_this.selection[colValidar - 1].texto] =
            data.nombre;
          _this.registros[fila][_this.selection[colValidar - 1].bd] = data._id;
          _this.registros[fila][_this.selection[colValidar - 1].valida] = true;
        } else {
          _this.registros[fila][this.selection[colValidar - 1].texto] = null;
          _this.registros[fila][this.selection[colValidar - 1].bd] = null;
          _this.registros[fila][_this.selection[colValidar - 1].valida] = false;
        }
      } else {
        _this.registros[fila][this.selection[colValidar - 1].texto] = null;
        _this.registros[fila][this.selection[colValidar - 1].bd] = null;
        _this.registros[fila][_this.selection[colValidar - 1].valida] = true;
      }
    },
    validaRenglon(fila) {
      this.validaCuenta(fila, this);
      const _this = this;
      this.selection.forEach(function (k, v) {
        if (v > 0) {
          _this.validaconcepto(fila, v + 1, _this);
        }
      });
      if (
        this.registros[fila].cumpleCuenta &&
        this.registros[fila].cumpleNit &&
        this.registros[fila].cumpleDescripcion &&
        this.registros[fila].cumpleRef &&
        this.registros[fila].cumpleCcosto &&
        this.registros[fila].cumpleBase &&
        this.registros[fila].cumpleProducto &&
        this.registros[fila].cumpleCantidad &&
        this.registros[fila].cumplePreciounitario &&
        this.registros[fila].cumpleBodega &&
        this.registros[fila].cumpleTipo1 &&
        this.registros[fila].cumpleValor
      ) {
        if (this.registros[fila].esTotal) {
          // si es el total
          this.registros[fila].tipo = this.comundata.comprobante.tipo;
        } else {
          // si no es el total
          if (
            this.comundata.comprobante.tipo === 1 &&
            this.registros[fila].tipo1 === "+"
          ) {
            this.registros[fila].tipo = "2";
          } else if (
            this.comundata.comprobante.tipo === 1 &&
            this.registros[fila].tipo1 === "-"
          ) {
            this.registros[fila].tipo = "1";
          } else if (
            this.comundata.comprobante.tipo === 2 &&
            this.registros[fila].tipo1 === "+"
          ) {
            this.registros[fila].tipo = "1";
          } else if (
            this.comundata.comprobante.tipo === 2 &&
            this.registros[fila].tipo1 === "-"
          ) {
            this.registros[fila].tipo = "2";
          }
        }
        this.registros[fila].mes = functions.mes(this.comundata.periodo);
        this.registros[fila].year = functions.year(this.comundata.periodo);
        this.registros[fila].fecha = new Date(
          functions.year(this.comundata.periodo),
          this.registros[fila].mes - 1,
          this.comundata.dia
        );
        this.registros[fila].comprobanteid = this.comundata.comprobante._id;
        this.registros[fila].grupo = functions.grupo(
          this.registros[fila].cuenta
        );
        this.registros[fila].sgrupo = functions.sgrupo(
          this.registros[fila].cuenta
        );
        this.registros[fila].scuenta = functions.scuenta(
          this.registros[fila].cuenta
        );
        if (!this.registros[fila].tBase) {
          this.registros[fila].base = 0;
        }
        if (!this.registros[fila].tDocref) {
          this.registros[fila].docRef = "0";
        }
        if (!this.registros[fila].tCcosto) {
          this.registros[fila].ccostos = "0";
        }
        if (!this.registros[fila].tNit) {
          this.registros[fila].idnit = this.empresa.nit0;
        }
        this.registros[fila].orden = fila;
        this.registros[fila].cumpleTodo = true;
      } else {
        this.registros[fila].cumpleTodo = false;
      }
    },
    determinaColumna(_this) {
      _this.selection.forEach(function (k, v) {
        if (k.cod === "valor") {
          _this.selcolumn.columnValor = v + 1;
        }
        if (k.cod === "base") {
          _this.selcolumn.columnBase = v + 1;
        }
        if (k.cod === "ccostos") {
          _this.selcolumn.columnccostos = v + 1;
        }
        if (k.cod === "docRef") {
          _this.selcolumn.columndocRef = v + 1;
        }
        if (k.cod === "ccostos") {
          _this.selcolumn.columnccostos = v + 1;
        }
        if (k.cod === "descripcion") {
          _this.selcolumn.columndescripcion = v + 1;
        }
        if (k.cod === "nit") {
          _this.selcolumn.columnnit = v + 1;
        }
        if (k.cod === "cuenta") {
          _this.selcolumn.columncuenta = v + 1;
        }
        if (k.cod === "tipo1") {
          _this.selcolumn.columntipo1 = v + 1;
        }
        if (k.cod === "nproducto") {
          _this.selcolumn.columnproducto = v + 1;
        }
        if (k.cod === "cantidad") {
          _this.selcolumn.columncantidad = v + 1;
        }
        if (k.cod === "vlrUnitario") {
          _this.selcolumn.columnpunitario = v + 1;
        }
        if (k.cod === "nbodega") {
          _this.selcolumn.columnbodega = v + 1;
        }
      });
    },
    createreg(_this, isSplice) {
      const d = {
        idcuenta: null,
        idnit: null,
        descripcion: null,
        fecha: null,
        documento: null, // aqui va el numero de documento que tiene la comundata
        comprobanteid: null, // aqui va el id del comprobante que lo tiene la coumndata
        docRef: null,
        ccostos: null,
        base: 0,
        tipo: null, // 1 para el debito y 2 para el credito
        valor: 0,
        year: null, // aqui va el año que viene de comundata
        mes: null, // aqui va el mes que viene de commundata
        // datosFactura: false, // este es para la factura
        turno: null, // este es para el id del turno en el caso que sea de un cuadre de caja
        tipor: null, // este es tipo de registro ingreso inventario costo o impuesto y solo aplica para punto de venta
        producto: null, // este es el id del producto para productos de punto de venta
        grupop: null, // este es el id del grupo del producto
        pventa: false, // este se pone true si es de punto de venta
        bodega: null, // este es el id de la bodega
        cantidad: 0, // numero de cantidades
        vlrUnitario: 0, // numero del valor unitario
        esTotal: false, // true o false para saber si es el total del documento
        descuento: null, // descuento este dato solo lo tiene las cuentas de ventas de la factura
        orden: null,
        // hasta aca es la estructura de la base de datos
        cuenta: null,
        cuentadetalle: null,
        nombreCuenta: null,
        nit: null,
        nombreNit: null,
        nombreCcostos: null,
        idCcostos: null,
        pptal: null,
        idpptal: null,
        nombrebodega: null,
        nbodega: null,
        nombreproducto: null,
        nproducto: null,
        productodetalle: null,
        porcentaje: null, // aqui va el porcentaje de retefuente
        tipo1: "+",
        tCuenta: true,
        tNit: false,
        tDescripcion: true,
        tCcosto: false,
        tBase: false,
        tDocref: false,
        tProducto: false,
        tCantidad: false,
        tPreciounitario: false,
        tBodega: false,
        tTipo: true,
        tValor: true,
        tDescuento: true,
        cumpleCuenta: true,
        cumpleNit: true,
        cumpleDescripcion: true,
        cumpleRef: true,
        cumpleCcosto: true,
        cumpleBase: true,
        cumpleProducto: true,
        cumpleCantidad: true,
        cumplePreciounitario: true,
        cumpleBodega: true,
        cumpleValor: true,
        cumpleTipo1: true,
        cumpleDescuento: true,
        cumpleTodo: false,
      };
      if (isSplice) {
        _this.registros.splice(_this.registros.length - 1, 0, d);
      } else {
        _this.registros.push(d);
      }
    },
    guardar(_this) {
      let cumpletodo = true;
      _this.registros.forEach(function (k, v) {
        if (_this.empresa.modulos.cuadrecaja) {
          k.turno = _this.turno._id;
        }
        if (k.valor === 0 && v !== 0 && !k.esTotal) {
          _this.registros.splice(v, 1);
        }
      });
      _this.registros.forEach(function (k, v) {
        if (
          _this.comundata.comprobante.estructura === "comercial" &&
          _this.comundata.comprobante.esfactura
        ) {
          if (_this.textoFactura) {
            k.datosFactura = {
              texto: _this.textoFactura,
            };
          }
        }
        _this.validaRenglon(v);
        if (!k.cumpleTodo) {
          cumpletodo = false;
        }
      });
      const total = _this.calculaTotal();
      _this.registros[this.registros.length - 1].valor = total;
      if (cumpletodo) {
        this.guardaRegistros(this);
      } else {
        _this.$emit("notifyguardado", { guardo: false });
        this.$store.dispatch("notify", {
          message:
            "No se puede guardar el registro, Debe corregir los campos resaltados en rojo.",
          type: "is-danger",
          position: "top-center",
          duration: 5000,
        });
      }
    },
    async guardaRegistros(_this) {
      let result;
      try {
        result = await apiServices.post(`/registroslote`, this.registros);
        _this.$emit("notifyguardado", { guardo: true, result: result.data });
        this.registros = [];
        this.$store.dispatch("notify", {
          message: "Registro guardado con éxito.",
          type: "is-primary",
          position: "top-center",
        });
      } catch (err) {
        _this.$emit("notifyguardado", { guardo: false });
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema guardando los registros.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema guardando los registros", err);
      }
    },
  },
  created() {
    if (this.comundata.comprobante.estructura === "comercial") {
      this.selection = selectioncomercial;
    }
    if (this.comundata.comprobante.estructura === "inventario") {
      this.selection = selectioninventario;
    }
    if (this.borrador) {
      this.determinaColumna(this);
      this.registros = this.borrador.registros;
    } else {
      this.determinaColumna(this);
      this.createreg(this, false);
      this.createreg(this, false);
      const contrapartida = functions.findData(
        this.cuentas,
        this.comundata.comprobante.cuenta,
        "_id"
      );
      this.registros[1].idcuenta = contrapartida._id;
      this.registros[1].esTotal = true;
      this.registros[1].cuenta = contrapartida.codigo;
      this.registros[1].idcuenta = contrapartida._id;
      this.registros[1].nombreCuenta = contrapartida.nombre;
      this.registros[1].orden = 100000;
      this.validaCuenta(1, this); // valido la cuenta de la contrapartida
    }
  },
  watch: {
    empresa(newv, oldv) {
      if (oldv._id !== newv._id) {
        this.registros = [];
      }
    },
    guardando(nv, ov) {
      if (nv) {
        this.guardar(this);
      }
    },
    fila(nv, ov) {
      const temporal = {
        comprobante: this.comundata.comprobante,
        dia: this.comundata.dia,
        documento: this.comundata.numDoc,
        registros: this.registros,
      };
      localStorage.setItem("temporal", JSON.stringify(temporal));
    },
    columna(nv, ov) {
      const temporal = {
        comprobante: this.comundata.comprobante,
        dia: this.comundata.dia,
        documento: this.comundata.numDoc,
        registros: this.registros,
      };
      localStorage.setItem("temporal", JSON.stringify(temporal));
      if (ov === this.selcolumn.columncuenta) {
        this.validaCuenta(this.fila, this);
      } else {
        if (ov === this.selcolumn.columnnit) {
          // aqui valida cuando salga del nit
          this.validaconcepto(this.fila, ov, this);
          if (
            !this.registros[this.fila].cumpleNit &&
            this.registros[this.fila].nit !== null
          ) {
            this.$store.commit("launchModalnit", this.registros[this.fila].nit);
            this.columna = this.selcolumn.columnnit;
          }
        } else {
          if (
            nv === this.selcolumn.columncuenta &&
            ov === this.selcolumn.columnValor
          ) {
          } else {
            this.validaconcepto(this.fila, ov, this);
          }
        }
      }
    },
    comprobanteSelected(nv, ov) {
      if (this.comundata.comprobante.estructura === "comercial") {
        this.selection = selectioncomercial;
      }
      if (this.comundata.comprobante.estructura === "inventario") {
        this.selection = selectioninventario;
      }
      this.registros = [];
      this.fila = 0;
      this.columna = 1;
      this.determinaColumna(this);
      this.createreg(this, false);
      this.createreg(this, false);
      const contrapartida = functions.findData(
        this.cuentas,
        this.comundata.comprobante.cuenta,
        "_id"
      );
      this.registros[1].idcuenta = contrapartida._id;
      this.registros[1].esTotal = true;
      this.registros[1].cuenta = contrapartida.codigo;
      this.registros[1].idcuenta = contrapartida._id;
      this.registros[1].nombreCuenta = contrapartida.nombre;
      this.registros[1].orden = 100000;
      this.validaCuenta(1, this); // valido la cuenta de la contrapartida
    },
  },
  components: {
    yFormregistro,
    yViewregistro,
  },
};
</script>


<style lang="scss" scoped>
.media1 {
  padding-top: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(219, 219, 219, 0.5);
}
.is-total {
  border-bottom: 10px solid rgba(219, 219, 219, 0.5);
  border-top: 9px solid rgba(219, 219, 219, 0.5);
}
</style>




// WEBPACK FOOTER //
// src/components/registrar/Estructura.vue